<template>
    <div class="fastdfs--list">
        <List  border size="small" v-show="files.length">
            <ListItem
                    v-for="(item, index) in files" :key="index"
                      class="list--item">
                <template v-if="item.status === 'finished' || item.filePath">
                    <div class="pointer" @click="common.downloadOssFile(item.id)">{{ item.fileName }}</div>
                </template>
                <template v-else>
                    <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template>
                <span class="upload-remove" @click="handleRemove(item, index)" v-if="isEdit"><Icon type="md-close" size="24"/> </span>
            </ListItem>
        </List>
        <!--:format="['jpg','jpeg','png','gif','rar','zip','7z','doc','docx']"-->
        <Upload
                ref="upload"
                :action="action"
                :headers="header"
                :show-upload-list="false"
                :on-format-error="handleFormatError"
                :format="format"
                :default-file-list="defaultList"
                :on-success="handleUpload"
                :on-error="uploadFail"
                :max-size="100240"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                v-if="isEdit && (only && files.length === 0 || !only)"
        >
            <div>
                <Button icon="ios-cloud-upload-outline" type="primary">上传</Button>
            </div>
        </Upload>
    </div>
</template>

<script>
    import { fastdfsDelete } from '@/api/user'
    export default {
        components: {

        },
        data(){
            return{
                header:{
                    // Authorization: 'Bearer '+ localStorage.getItem('access_token')
                },
                // 上传列表
                files:[],
                headers:{
                    // Authorization: 'Bearer '+ localStorage.getItem('access_token')
                }
            };
        },
        props: {
            action: {
              type: String,
              default: '/jg/services/fastdfs/upload'
            },
            format: {
              type: Array,
              default() {
                  return []
              }
            },
            // 默认列表
            defaultList:{
                type: Array,
                default() {
                    return []
                }
            },
            isEdit:{
                type:Boolean,
                default:true
            },
            only:{
                type:Boolean,
                default:false
            },
        },
        created() {

        },
        mounted(){
            this.init();
        },
        watch: {

        },
        methods:{
            init() {
                console.log(this.$refs.upload.fileList)
                this.files = this.$refs.upload.fileList;
                // console.log(this.files)
            },
            uploadType(type){
                let cstr='';
                switch (type) {
                    case 'yasuo':
                        cstr='upload-yasuo';
                        break;
                    case 'word':
                        cstr='upload-word';
                        break;
                    case 'excel':
                        cstr='upload-excel';
                        break;
                    case 'ppt':
                        cstr='upload-ppt';
                        break;
                    default:
                        cstr='upload-others';
                }
                return cstr;
            },
            //获取文件后缀
            handleSuffix(filename){
                //这里设置单个图片时的名称
                let reg=/\.(jpg|jpeg|png|bmp|gif)$/i;
                let word=/\.(doc|docx)$/i;
                let yasuo=/\.(rar|zip|7z)$/i;
                let pdf=/\.(pdf)$/i;
                let excel = /\.(xlsx)$/i;
                if(reg.test(filename)){
                    return 'img';
                }else if(yasuo.test(filename)){
                    return 'yasuo';
                }else if(pdf.test(filename)){
                    return 'pdf';
                }else if(excel.test(filename)){
                    return 'xlsx';
                }else if(word.test(filename)){
                    return 'word';
                }else{
                    return 'others';
                }

            },
            //上传模块
            /*标签删除*/
            handleRemove(item, index){
                fastdfsDelete(item.id).then(() => {
                    this.$Message.success('删除成功!');
                    const fileList = this.$refs.upload.fileList;
                    this.$refs.upload.fileList.splice(index, 1);
                    // this.files = this.$refs.upload.fileList;
                    // this.files.splice(index, 1);
                    /*发送更新值 以便父组件.sync接收*/
                    // this.$emit('update:uploadList',this.$refs.upload.fileList);
                });
            },
            /*上传成功*/
            handleUpload(response, file){
                // console.log(response)
                // console.log(file)
                if (response.success) {
                    file.fileName = response.fileName;
                    file.filePath = response.diskFileName;
                    file.id = response.id;
                    delete file.response;
                    // this.$set(this.files, this.files.length, file)
                    // this.files.push(file);
                    // this.$emit("update:uploadList",  this.files);
                    this.$Message.success("上传成功");
                } else {
                    this.$Message.error("上传失败！");
                }
            },
            /*上传失败*/
            uploadFail(){
                this.$Message.error('上传失败！');
            },
            /*文件过大*/
            handleMaxSize(file){
                this.$Notice.warning({
                    title: '文件过大',
                    desc: file.name + ' 文件太大,不能超过10M.'
                });
            },
            /*格式验证失败*/
            handleFormatError (file) {
                this.$Message.error('文件格式不支持！');
            },
            /*最多上传*/
            handleBeforeUpload(){
                // const check = this.files.length < 5;
                // if (!check) {
                //     this.$Notice.warning({
                //         title: '最多可上传5个'
                //     });
                // }
                // return check;
            },
        },
    };
</script>

<style scoped lang="less">
    .fastdfs--list{
        .pointer {
            cursor: pointer;
            color: #0080E1;
        }
        .list--item{
            position: relative;
        }
        .upload-remove{
            position: absolute;right: 2px;top: 2px;
            font-size: 20px;
            line-height: 20px;
            cursor: pointer;
        }
    }
</style>
